import Icon from "ds/components/Icon";
import { ArrowRight } from "components/icons/generated";
import { EntityChangeType } from "types/generated";

import { CodeChangesValueNode } from "../types";
import styles from "../styles.module.css";
import ValueType from "./ValueType";

type ValueProps = {
  item: CodeChangesValueNode;
};

const Value = ({ item }: ValueProps) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (item.type) {
    case EntityChangeType.Change:
    case EntityChangeType.ReplaceCreateBeforeDestroy:
    case EntityChangeType.ReplaceDestroyBeforeCreate:
      return (
        <>
          <ValueType>{item.before}</ValueType>
          <Icon className={styles.codeChangesArrow} src={ArrowRight} />
          <ValueType>{item.after}</ValueType>
        </>
      );
    case EntityChangeType.Delete:
      return <ValueType>{item.before}</ValueType>;
    case EntityChangeType.Noop:
    case EntityChangeType.Add:
      return <ValueType>{item.after}</ValueType>;
    default:
      return <span>Unknown change type</span>;
  }
};

export default Value;
